import { render, staticRenderFns } from "./u-tab-filled.vue?vue&type=template&id=67bffd9a&scoped=true&"
import script from "./u-tab-filled.vue?vue&type=script&lang=js&"
export * from "./u-tab-filled.vue?vue&type=script&lang=js&"
import style0 from "./u-tab-filled.vue?vue&type=style&index=0&id=67bffd9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bffd9a",
  null
  
)

export default component.exports